module.exports = __webpack_public_path__ + "static/media/building.3ce7c7ec.svg";